import React from "react";
import TokenEditor from "../Builder/Components/TokenEditor";
import HelpButton from "../HelpContent/HelpButton";
import SMSCounter from "../Builder/Components/SMSCounter";

export default function BroadcastEditorMessagePane({
  message,
  onChange,
  isFileImport,
  SignatureModal,
  tokenTags,
}) {
  return (
    <>
      {
        // Welcome message for voice
        message.Channel === "voice" && (
          <div className="row my-3 ">
            <label className="col-2 fw-bold ">
              Welcome message:
              <HelpButton helpKey="broadcast-voice-welcome-message" />
            </label>
            <div className="col-10">
              <textarea
                className="form-control"
                value={message.WelcomeMessage || ""}
                onChange={(e) =>
                  onChange({
                    ...message,
                    WelcomeMessage: e.target.value,
                  })
                }
              />
            </div>
          </div>
        )
      }

      <div className="row my-3">
        {message.Channel === "voice" && (
          <div className="col-2 fw-bold">
            Main message content:
            <HelpButton helpKey="broadcast-main-message" />
          </div>
        )}

        <div className="col">
          <div className="row">
            {/* Main editor */}
            <div>
              {message.Channel === "email" && (
                <>
                  <div className="row my-3 bg-purple-gradient p-3 rounded-3 m-1">
                    <div className="col-2">
                      <label className="fw-bold">
                        Email subject{" "}
                        <HelpButton helpKey="broadcast-email-subject" />
                      </label>
                    </div>
                    <div className="col-10">
                      <TokenEditor
                        showShortlinksButton={false}
                        tokenTags={(
                          tokenTags || [
                            "contact_field",
                            "imported_contact_field",
                          ]
                        )
                          .filter((t) => t !== "assets")
                          .map((t) =>
                            t === "ping_status" ? "ping_status_short" : t
                          )
                          .map((t) => (t === "weather" ? "weather_short" : t))}
                        rawEditorState={message?.EmailSubject?.EditorState}
                        onChange={({
                          rawEditorState,
                          HTMLtext,
                          tokens,
                          plainText,
                          links,
                          shortlinks,
                        }) => {
                          onChange(
                            {
                              ...message,
                              EmailSubject: {
                                EditorState: rawEditorState,
                                PlainText: plainText,
                              },
                              Tokens: [
                                ...(message.Tokens || []).filter(
                                  (t) => t.UsedIn !== "EmailSubject"
                                ),
                                ...(tokens?.map((t) => ({
                                  ...t,
                                  UsedIn: "EmailSubject",
                                })) || []),
                              ],
                            },
                            {
                              usedIn: "EmailSubject",
                              tokens,
                            }
                          );
                        }}
                        style={undefined}
                        label={undefined}
                        showButtons={undefined}
                        preview={undefined}
                        initialText={undefined}
                      />
                    </div>
                  </div>
                  <div className="row my-3 bg-purple-gradient p-3 rounded-3 m-1">
                    <div className="col-2">
                      <label className="fw-bold">
                        Email From <HelpButton helpKey="broadcast-email-from" />
                      </label>
                    </div>
                    <div className="col-10">
                      <TokenEditor
                        showShortlinksButton={false}
                        tokenTags={(
                          tokenTags || [
                            "contact_field",
                            "imported_contact_field",
                          ]
                        )
                          .filter((t) => t !== "assets")
                          .map((t) =>
                            t === "ping_status" ? "ping_status_short" : t
                          )
                          .map((t) => (t === "weather" ? "weather_short" : t))}
                        rawEditorState={message?.EmailFrom?.EditorState}
                        onChange={({
                          rawEditorState,
                          HTMLtext,
                          tokens,
                          plainText,
                          links,
                          shortlinks,
                        }) => {
                          onChange(
                            {
                              ...message,
                              EmailFrom: {
                                EditorState: rawEditorState,
                              },
                              Tokens: [
                                ...(message.Tokens || []).filter(
                                  (t) => t.UsedIn !== "EmailFrom"
                                ),
                                ...(tokens?.map((t) => ({
                                  ...t,
                                  UsedIn: "EmailFrom",
                                })) || []),
                              ],
                            },
                            {
                              usedIn: "EmailFrom",
                              tokens,
                            }
                          );
                        }}
                        style={undefined}
                        label={undefined}
                        showButtons={undefined}
                        preview={undefined}
                        initialText={undefined}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="large-editor border rounded-3 p-1">
                <TokenEditor
                  key={message.Uuid}
                  tokenTags={
                    tokenTags || [
                      "shortlinks",
                      "contact_field",
                      ...(isFileImport ? ["imported_contact_field"] : []),
                    ]
                  }
                  showButtons={message.Channel === "email"}
                  rawEditorState={message.Message.EditorState}
                  showShortlinksButton={message.Channel !== "voice"}
                  onChange={({
                    rawEditorState,
                    HTMLtext,
                    tokens,
                    plainText,
                    links,
                    shortlinks,
                  }) => {
                    onChange(
                      {
                        ...message,
                        Message: {
                          EditorState: rawEditorState,
                          PlainText: plainText,
                        },
                        Shortlinks: shortlinks,
                        Tokens: [
                          ...(message.Tokens || []).filter(
                            (t) => t.UsedIn !== "message"
                          ),
                          ...(tokens?.map((t) => ({
                            ...t,
                            UsedIn: "message",
                          })) || []),
                        ],
                      },
                      {
                        usedIn: "message",
                        tokens,
                      }
                    );
                  }}
                />
              </div>
              {message.Channel === "email" && <SignatureModal />}
            </div>
          </div>
        </div>
      </div>

      {
        // Exit message for voice
        message.Channel === "voice" && (
          <div className="row my-3">
            <label className="col-2 fw-bold">
              Exit message:{" "}
              <HelpButton helpKey="broadcast-voice-exit-message" />
            </label>
            <div className="col-10">
              <textarea
                className="form-control"
                value={message.ExitMessage || ""}
                onChange={(e) =>
                  onChange({
                    ...message,
                    ExitMessage: e.target.value,
                  })
                }
              />
            </div>
          </div>
        )
      }
    </>
  );
}
